import { ErrorHandler, Injectable } from '@angular/core';
import { SnackbarService } from '@shared/services/core/snackbar.service';

@Injectable()
export class ErrorService implements ErrorHandler {

  constructor(private snackBService: SnackbarService) { }

  handleError(error: unknown): void {
    if (error instanceof Error) {
      //debugger;
      //console.error(`[App Error Handler] `, error.name, error.message);
     // console.log(error);
      // HERE: Call the log service and create a log entry.
      // this.snackBService.showErrorSnackBar(error.name, error.message, 'none' );
    }
  }
}
